import { IParseExportPaymentsResponse } from "@shared/lib/types/briefCampains";
import { getParseRowAmount, getParseRowName } from "../../lib/parseExportRows";
import { formatPayoutAmount } from "../../lib/payoutDisplay";
import styles from "./styles.module.scss";

type ParsePreviewKind = "success" | "failed" | "cannotImport";

type PayoutParsePreviewListProps = {
  rows: IParseExportPaymentsResponse[];
  kind: ParsePreviewKind;
};

export function PayoutParsePreviewList({
  rows,
  kind,
}: PayoutParsePreviewListProps) {
  if (rows.length === 0) {
    return <p className={styles.empty}>No rows in this tab.</p>;
  }

  return (
    <div className={styles.list}>
      {rows.map((row, index) => (
        <div
          key={`${row.vendorPaymentId || "row"}-${row.rowNumber ?? index}`}
          className={`${styles.row} ${styles[kind]}`}
        >
          <div className={styles.header}>
            <span className={styles.name}>{getParseRowName(row)}</span>
            <span className={styles.amount}>
              {formatPayoutAmount(getParseRowAmount(row))}
            </span>
          </div>
          {kind === "success" && row.utrNo ? (
            <div className={styles.meta}>UTR {row.utrNo}</div>
          ) : null}
          {kind === "failed" ? (
            <div className={styles.reason}>
              {row.rejectionReason || "Failed"}
              {row.utrNo ? ` · UTR ${row.utrNo}` : ""}
            </div>
          ) : null}
          {kind === "cannotImport" ? (
            <div className={styles.reason}>
              {(row.errors && row.errors.length > 0
                ? row.errors
                : [row.message || "Could not import this row"]
              ).join(" · ")}
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
}
